import { Table } from 'antd';
import { pagination } from '../../../../../common/utils/common.utils';
import { loadingIndicator } from '../../../../../components/common/spinner/LoadingIndicator';
import { useGetAllFollowupClientQuery } from '../../api/endpoints/clientEndpoints';
import { IClientPassportData } from '../../types/clientInterfaces';
import { clientFollowupUtil } from '../../utils/utils_tsx/clientFollowupUtil';

type Props = { id: any };

const ClientDetailFollowup = ({ id }: Props) => {
  const { data, isLoading } = useGetAllFollowupClientQuery(id, {
    selectFromResult: (cache) => {
      const data = cache.data?.data;
      const dataToReturn: IClientPassportData[] = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          dataToReturn.push({
            ...element,
            key: i + 1,
          });
        }
      }
      return { ...cache, data: dataToReturn };
    },
  });
  return (
    <div>
      <Table
        size='small'
        bordered
        columns={clientFollowupUtil()}
        dataSource={Array.isArray(data) ? data : ([] as any)}
        pagination={pagination(data?.length)}
        scroll={{ x: true }}
        loading={{
          spinning: isLoading,
          indicator: loadingIndicator,
        }}
      />
    </div>
  );
};

export default ClientDetailFollowup;
